// extracted by mini-css-extract-plugin
export default {"switch-account":"HfzM7M","modal":"LzKNca","portal":"URLauq","title":"ZDGi1L","description":"FdJVdi"};